window.KycAmlStatuses = {}